import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { Enum } from 'app/model/enum';
import { environment } from 'environments/environment';

@Injectable()
export class DadosExcecoesService {
    
    private path = environment.url + 'api/v1/';

    constructor(private http: HttpClient) {}

    getAnosDisponiveisCampanha(tipoCampanha): Observable<any> {
        return this.http.get<any>(this.path + `excecao/anos/${tipoCampanha}`);
    }

    getExcecao(dadosServidor, pagina, tamanho): Observable<any> {
        const começaComNúmero = /^\d/.test(dadosServidor);
        let nome = '';
        let matricula = 0;
      
        if (começaComNúmero) {
          matricula = dadosServidor;
        } else {
          nome = dadosServidor;
        }
        return this.http.get<any>(this.path + `excecao?nome=${nome}&matricula=${matricula}&pagina=${pagina}&itens=${tamanho}`);
    }

    getServidor(dadosServidor): Observable<any> {
        const começaComNúmero = /^\d/.test(dadosServidor);
        let nome = '';
        let matricula = 0;
      
        if (começaComNúmero) {
          matricula = dadosServidor;
        } else {
          nome = dadosServidor;
        }
        return this.http.get<any>(`${this.path}excecao/servidor?nome=${nome}&matricula=${matricula}&pagina=0&itens=10`);
    }

    getTodasLinhasTransporte(pagina, tamanho, filtro): Observable<any> {
        const começaComNúmero = /^\d/.test(filtro);
        console.log(começaComNúmero)
        let params = {
            descLinha: filtro,
            codgLinhaPref: ''
        };
        if (começaComNúmero == false) {
            params.descLinha = filtro
            params.codgLinhaPref = ''
        } else {
            params.descLinha = ''
            params.codgLinhaPref = filtro
        }
        return this.http.get<any>(this.path + 'linha' + `/pagina/${pagina}/tamanho/${tamanho}`, { params: params });
    }

    adicionarExcecao(data): Observable<any> {
        return this.http.post(this.path + 'excecao', data);
    }
}